// extracted by mini-css-extract-plugin
export default {"container":"miJNYGv8VvvTKyDU5FIP"};